const CONSENT_COOKIE_KEY = 'CookieConsent';
const CATEGORY_NECESSARY = 'necessary';
const CATEGORY_STATISTICS = 'statistics';
const CATEGORY_MARKETING = 'marketing';

export {
    CONSENT_COOKIE_KEY,
    CATEGORY_NECESSARY,
    CATEGORY_STATISTICS,
    CATEGORY_MARKETING,
};
